/**
 * Memory scope values.
 */
export const MemoryScope = {
  Session: 0,
  Project: 1,
  Tenant: 2,
} as const;

export type MemoryScope = (typeof MemoryScope)[keyof typeof MemoryScope];

/**
 * Memory type values.
 */
export const MemoryType = {
  Fact: 0,
  Decision: 1,
  Outcome: 2,
  Preference: 3,
} as const;

export type MemoryType = (typeof MemoryType)[keyof typeof MemoryType];

/**
 * Agent memory entry DTO.
 */
export interface AgentMemoryEntryDto {
  id: string;
  tenantId: string;
  projectId?: string;
  sessionId?: string;
  agentDefinitionId: string;
  scope: MemoryScope;
  type: MemoryType;
  content: string;
  summary?: string;
  importanceScore: number;
  tags: string[];
  expiresAt?: string;
  accessCount: number;
  lastAccessedAt?: string;
  metadataJson?: string;
  createdAt: string;
  updatedAt: string;
}

/**
 * Request model for storing a memory entry.
 */
export interface StoreMemoryRequest {
  agentDefinitionId: string;
  sessionId?: string;
  scope: MemoryScope;
  type: MemoryType;
  content: string;
  summary?: string;
  tags?: string[];
  metadataJson?: string;
  expiresAt?: string;
  importanceScoreOverride?: number;
}

/**
 * Filters for memory queries.
 */
export interface MemoryFilters {
  sessionId?: string;
  scope?: MemoryScope;
  type?: MemoryType;
  minImportanceScore?: number;
  query?: string;
  useSemanticSearch?: boolean;
  limit?: number;
  includeProjectScope?: boolean;
  includeTenantScope?: boolean;
}

